export default "__VITE_ASSET__4e27309f__"